import React from "react";

import { getCoreSubjectListForWorkspace } from "@examspark/common/dist/meta/assets";
import { subjectMeta } from "@examspark/common-meta";
import { SelectInput, SelectInputOption } from "@examspark/common-ui";

import { useAppContext } from "../../../providers/AppContext";

const SubjectSelectInput = (
  props: React.ComponentProps<
    typeof SelectInput<string, SelectInputOption<string>, false>
  > & {
    allowedSubjects?: string[];
  },
) => {
  const [appState] = useAppContext();
  const availableSubjects = getCoreSubjectListForWorkspace(
    appState.workspace?.id,
  );

  return (
    <SelectInput<string, SelectInputOption<string>, false>
      options={availableSubjects
        .filter((subject) => {
          if (
            props.allowedSubjects &&
            !props.allowedSubjects.includes(subject)
          ) {
            return false;
          }

          return true;
        })
        .map((subject) => {
          return {
            label: subjectMeta[subject].label,
            value: subject,
          };
        })}
      {...props}
    />
  );
};

export default SubjectSelectInput;
